import { useState } from "react"
import { format, subDays } from "date-fns"
import { DateRange } from "react-day-picker"
import { Popover, PopoverContent, PopoverTrigger } from "../../../@/components/ui/popover"
import { cn } from "@/lib/utils"
import { Button } from "../../../@/components/ui/button"
import { Calendar as CalendarComponent } from '../../../@/components/ui/calendar';

import { Calendar as CalendarIcon } from 'lucide-react';
import { useDispatch } from "react-redux"
import { AppDispatch } from "store/store"
import { setDateRange } from "store/AnaliticsSlice"

export function CalendarDateRangePicker() {
  const dispatch: AppDispatch = useDispatch();
  const today =new Date();  
  const [date, setDate] = useState<DateRange | undefined>({
      from: subDays(today,30),
      to: today,
    });

    const handleDateSelect = (value: DateRange | undefined) => {
      setDate(value);
      // Dispatch the date range to Redux store
      if (value?.from && value?.to) {
        dispatch(setDateRange({
          startDate: value.from,
          endDate: value.to
        }));
      }
    };
  
    return (
      <div className={cn("grid gap-2")}>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              id="date"
              variant={"outline"}
              className={cn(
                "w-[260px] justify-start text-left font-normal",
                !date && "text-muted-foreground"
              )}
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {date?.from ? (
                date.to ? (
                  <>
                    {format(date.from, "LLL dd, y")} -{" "}
                    {format(date.to, "LLL dd, y")}
                  </>
                ) : (
                  format(date.from, "LLL dd, y")
                )
              ) : (
                <span>Pick a date</span>
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="end">
            <CalendarComponent
              initialFocus
              mode="range"
              defaultMonth={date?.from}
              selected={date}
              onSelect={handleDateSelect}
              numberOfMonths={2}
            />
          </PopoverContent>
        </Popover>
      </div>
    );
  }
  